import script from "./mainFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./mainFooter.vue?vue&type=script&setup=true&lang=ts"

import "./mainFooter.vue?vue&type=style&index=0&id=2805e23a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2805e23a"]])

export default __exports__